export default __webpack_public_path__ + "static/media/intro1.7cb4e8a4.mp3";